import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var t = /*#__PURE__*/function () {
  function t(_t, e, s, i) {
    _classCallCheck(this, t);

    this.view = _t, this.native = e, this.vertexIndex = s, this.vertices = i, this.defaultPrevented = !1, this.type = "vertex-add";
  }

  _createClass(t, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.defaultPrevented = !0;
    }
  }]);

  return t;
}();

var e = /*#__PURE__*/function () {
  function e(t, _e, s, i) {
    _classCallCheck(this, e);

    this.view = t, this.native = _e, this.vertexIndex = s, this.vertices = i, this.defaultPrevented = !1, this.type = "vertex-update";
  }

  _createClass(e, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.defaultPrevented = !0;
    }
  }]);

  return e;
}();

var s = /*#__PURE__*/function () {
  function s(t, e, _s, i) {
    _classCallCheck(this, s);

    this.view = t, this.native = e, this.vertexIndex = _s, this.vertices = i, this.defaultPrevented = !1, this.type = "vertex-remove";
  }

  _createClass(s, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.defaultPrevented = !0;
    }
  }]);

  return s;
}();

var i = /*#__PURE__*/function () {
  function i(t, e, s, _i) {
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    _classCallCheck(this, i);

    this.view = t, this.native = e, this.vertexIndex = s, this.vertices = _i, this.mapPoint = r, this.coordinates = null, this.defaultPrevented = !1, this.type = "cursor-update", this.coordinates = 1 === _i.length ? _i[0] : null;
  }

  _createClass(i, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.defaultPrevented = !0;
    }
  }]);

  return i;
}();

var r = /*#__PURE__*/function () {
  function r(t, e) {
    _classCallCheck(this, r);

    this.native = t, this.vertices = e, this.coordinates = null, this.defaultPrevented = !1, this.type = "draw-complete", this.coordinates = 1 === e.length ? e[0] : null;
  }

  _createClass(r, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.defaultPrevented = !0;
    }
  }]);

  return r;
}();

export { i as CursorUpdateEvent, r as DrawCompleteEvent, t as VertexAddEvent, s as VertexRemoveEvent, e as VertexUpdateEvent };